import { useState } from 'react';

interface FAQ {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  faqs: FAQ[];
}

export default function FAQSection({ faqs }: FAQSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-20 bg-background-100/60">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            关于看片网站的常见疑问
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            关于在线观影最常被问到的问题，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-50/80 transition-colors"
                onClick={() => toggleFAQ(index)}
              >
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {faq.question}
                </h3>
                <div className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 ${
                  openIndex === index ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}